import type { RootState } from "../../redux";
import { languages, texts } from "../../languages";
import { LocalStorageKeys } from "../../constants";
import type { Language, LanguageSelectState, Translation } from "../../types";
import { createSlice } from "@reduxjs/toolkit";

const initialState: LanguageSelectState = {
  languages,
  text: texts.english,
  textDirection: "ltr",
  isInitialLanguage: false,
};

export const languageSelectSlice = createSlice({
  name: "languageSelect",
  initialState,
  reducers: {
    setCurrentLanguage: (state, { payload }: { payload: Language }) => {
      state.textDirection = texts[payload].textDirection;
      state.text = texts[payload] as Translation;

      localStorage.setItem(LocalStorageKeys.language, payload);
    },

    setIsInitialLanguage: (state) => {
      state.isInitialLanguage = true;
    },

    setCurrentLanguageFromOverride: (state, { payload }: { payload: Language }) => {
      state.textDirection = texts[payload].textDirection;
      state.text = texts[payload] as Translation;
      state.isInitialLanguage = true;
    },
  },
});

export const { setCurrentLanguage, setIsInitialLanguage, setCurrentLanguageFromOverride } = languageSelectSlice.actions;

export const selectLanguages = (state: RootState) => state.languageSelect.languages;
export const selectText = (state: RootState) => state.languageSelect.text;
export const selectTextDirection = (state: RootState) => state.languageSelect.textDirection;
export const selectIsInitialLanguage = (state: RootState) => state.languageSelect.isInitialLanguage;

export default languageSelectSlice.reducer;
